import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import { GetAllPaymentDetail_Pay, deletePayment } from "../../api";
import { Header, Button } from "../../components";
import "../../styles/viewCustomer.css";
import { useStateContext } from "../../contexts/ContextProvider";
import { Col, Container, Row } from "react-bootstrap";
import { usePromiseTracker, trackPromise } from "react-promise-tracker";
import {
  showSuccessToast,
  showErrorToast,
  showInfoToast,
} from "../../components/ToastMesg";
import DataGrid from "../../components/DataGrid";

const Payment = () => {
  const navigate = useNavigate();
  const { storeG, userPermID } = useStateContext();
  const [AllPayments, setAllPayments] = useState("");
  const [Payment, setPayment] = useState(null);
  const { promiseInProgress } = usePromiseTracker();
  const [loading, setloading] = useState(false);

  const handleRowSelected = (args) => setPayment(args.data);
  const paymentIdCol = (props) => <div>{"P" + props.payment_id}</div>;
  const poIdCol = (props) => (
    <div>{props.po_id === 0 ? "-" : "PO" + props.po_id}</div>
  );

  const paymentsGrid = [
    {
      headerText: "ID",
      field: "payment_id",
      template: paymentIdCol,
      minWidth: "90",
      width: "90",
      maxWidth: "100",
      textAlign: "right",
    },
    {
      field: "datetime",
      headerText: "DateTime",
      type: "dateTime",
      format: "dd/MM/yyyy HH:mm",
      minWidth: "150",
      width: "155",
      maxWidth: "160",
      textAlign: "Center",
    },
    {
      field: "acc_from",
      headerText: "From",
      minWidth: "180",
      width: "200",
      maxWidth: "320",
      textAlign: "left",
    },
    {
      field: "acc_to",
      headerText: "To",
      minWidth: "180",
      width: "200",
      maxWidth: "320",
      textAlign: "left",
    },
    {
      field: "amount_paid",
      headerText: "Amt Paid",
      minWidth: "140",
      width: "140",
      maxWidth: "160",
      format: "C2",
      textAlign: "right",
    },
    {
      field: "po_id",
      headerText: "PO#",
      template: poIdCol,
      minWidth: "100",
      width: "100",
      maxWidth: "110",
      textAlign: "center",
    },
    {
      field: "note",
      headerText: "Note",
      minWidth: "140",
      width: "160",
      maxWidth: "360",
      textAlign: "left",
    },
  ];

  const handleAddPaymentClick = async (event) => {
    TimeoutUtility.resetTimeout();
    event.preventDefault();
    navigate(`/Payment/AddPayment`);
  };

  const handleEditPaymentClick = async (event) => {
    TimeoutUtility.resetTimeout();
    event.preventDefault();
    if (Payment && Payment.payment_id !== "") {
      if (Payment.po_id === 0)
        navigate(`/Payment/EditPayment/${Payment.payment_id}`);
      else
        showInfoToast(
          "Info!",
          `P${Payment.payment_id} is created with Purchase Order!\nEdit this with Purchase Order.`,
        );
    } else showInfoToast("Info!", "Please select payment to edit!");
  };

  const handleDeletePaymentClick = async (event) => {
    TimeoutUtility.resetTimeout();
    event.preventDefault();
    if (Payment && Payment.payment_id !== "") {
      var p_id = Payment.payment_id;
      if (Payment.po_id === 0) {
        if (
          window.confirm(`Are you sure you want to delete P${p_id} payment?`)
        ) {
          const resp = await deletePayment(p_id);
          if (resp.success) {
            showSuccessToast("Success!", "Payment deleted successfully.");
            window.location.reload();
          } else showErrorToast("Error!", "Payment failed to delete.");
        }
      } else
        showInfoToast(
          "Info!",
          `P${p_id} is created with Purchase Order!\nDelete this with Purchase Order.`,
        );
    } else showInfoToast("Info!", "Please select payment to delete!");
  };

  const handleViewPaymentClick = () => {
    TimeoutUtility.resetTimeout();
    if (Payment && Payment.payment_id !== "")
      navigate(`/Payment/ViewPayment/${Payment.payment_id}`);
    else showInfoToast("Info!", "Please select Payment to view!");
  };

  const handleRefresh = async () => {
    if (storeG?.store_id) {
      const resp = await GetAllPaymentDetail_Pay(storeG.store_id);
      setAllPayments(resp.data || []);
    }
  };

  useEffect(() => {
    async function fetchData() {
      if (storeG?.store_id) {
        TimeoutUtility.resetTimeout();
        setloading(true);
        trackPromise(
          GetAllPaymentDetail_Pay(storeG.store_id)
            .then((result) => setAllPayments(result.data || []))
            .catch((err) => console.log(err.message))
            .finally(() => setloading(false)),
        );
      }
    }
    fetchData();
  }, [storeG]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      <Header category="Financials" title="PAYMENT" />
      <Container fluid className="g-0 p-0 justify-end">
        <Row xs={2} className="button-row justify-content-end font-normal">
          {userPermID.includes(38) && (
            <Col md="auto p-0">
              <Button text="Add" onClick={handleAddPaymentClick} />
            </Col>
          )}
          {userPermID.includes(39) && (
            <>
              <Col md="auto p-0">
                <Button text="Update" onClick={handleEditPaymentClick} />
              </Col>
              <Col md="auto p-0">
                <Button text="Delete" onClick={handleDeletePaymentClick} />
              </Col>
            </>
          )}
        </Row>
      </Container>
      <DataGrid
        loading={loading || promiseInProgress}
        data={AllPayments}
        cols={paymentsGrid}
        handleRowSelected={handleRowSelected}
        handleDoubleClick={userPermID.includes(37) && handleViewPaymentClick}
        persistant={true}
        handleRefresh={handleRefresh}
      />
    </div>
  );
};

export default Payment;
